import styled from 'styled-components';
import { color, container, fontWeight, spacing } from 'theme';

export const StyledSection = styled.div`
  background-color: ${color('midnight_100')};
`;

export const StyledContainer = styled.div`
  padding: ${spacing('xl5')} ${spacing('md')};
  max-width: ${container('xl')};
  margin: auto;
  text-align: center;
`;

export const StyledCompanies = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: ${spacing('xl')} ${spacing('xl4')};
  margin-top: ${spacing('xl')};
  margin-bottom: ${spacing('xl')};

  img {
    max-height: ${spacing('xl')};
  }
`;

export const StyledMore = styled.div`
  max-width: ${container('sm')};
  margin: ${spacing('xl')} auto;
  text-transform: uppercase;
  color: ${color('text_subtle')};
  font-weight: ${fontWeight('extraBold')};
  position: relative;

  span {
    background-color: ${color('midnight_100')};
    padding-left: ${spacing('xs')};
    padding-right: ${spacing('xs')};
    z-index: 1;
    position: relative;
  }

  &::before {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    top: 50%;
    height: 1px;
    background-color: ${color('midnight_200')};
  }
`;
